import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    mainWrapper: {
        borderTop: `1px solid ${theme.palette.border.select}`,
        borderBottom: `1px solid ${theme.palette.border.select}`,
        marginBottom: theme.spacing(12),
        backgroundColor: theme.palette.primary.main,
        padding: theme.spacing(6),
    },
    label: {
        fontSize: 12,
        fontWeight: 700,
        color: theme.palette.primary.dark,
        textTransform: "uppercase",
        marginBottom: theme.spacing(1.5),
    },
    select: {
        maxWidth: 237,
        backgroundColor: theme.palette.primary.main,
        "& fieldset": {
            borderColor: theme.palette.border.select,
        },
        "& .MuiSelect-select": {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            "&.MuiInputBase-input": {
                flexDirection: "column",
                alignItems: "self-start",
            },
            fontSize: 14,
            fontWeight: 400,
            color: theme.palette.primary.darker,
            fontFamily: "Source Sans 3",
            padding: `${theme.spacing(2.25)} ${theme.spacing(3)}`,
        },
    },
    selectNoFlex: {
        "& .MuiSelect-select": {
            display: "block",
        },
    },
    filtersWrapper: {
        display: "grid",
        rowGap: theme.spacing(3),
        columnGap: theme.spacing(2),
        gridTemplateColumns: "repeat(auto-fit, minmax(230px, 1fr))",
    },
    filtersActionsWrapper: {
        marginTop: theme.spacing(6),
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        gap: theme.spacing(3),
    },
    selectWrapper: {
        display: "flex",
        flexDirection: "column",
    },
    datePickersWrapper: {
        display: "flex",
        flexDirection: "column",
    },
    datePicker: {
        minHeight: "1.4375em",
        minWidth: 230,
        padding: `${theme.spacing(3)} ${theme.spacing(3)} !important`,
        fontSize: 14,
        border: `1px solid ${theme.palette.border.select} !important`,
        borderRadius: 4,
    },
    mainWrapperLoading: {
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        display: "flex",
    },
    menuItem: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between !important",
        gap: theme.spacing(1),
        fontSize: `14px !important`,
        "&.Mui-selected": {
            backgroundColor: `${theme.palette.secondary.main} !important`,
        },
    },
    link: {
        display: "flex",
        gap: theme.spacing(4),
        color: theme.palette.info.main,
        fontFamily: "Source Sans 3",
        fontWeight: 700,
        fontSize: 12,
        textDecorationLine: "underline",
        textTransform: "uppercase",
        cursor: "pointer",
    },
    headerActionWrapper: {
        display: "flex",
        alignItems: "center",
        gap: 6,
        cursor: "pointer",
        textDecorationLine: "underline",
    },
}));
